// extracted by mini-css-extract-plugin
export var section = "index-module--section--PLell";
export var section__title = "index-module--section__title---q5m9";
export var section__text = "index-module--section__text--Os6O2";
export var section__image = "index-module--section__image--Ten+Z";
export var img = "index-module--img--N0CNQ";